(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mobile-sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    (() => {
    const bars = document.querySelectorAll('.pr-mobile-sticky-atc');

    bars.forEach((bar) => {
      if (bar.dataset.initialized === 'true') return;
      bar.dataset.initialized = 'true';

      const sectionId = bar.dataset.sectionId;
      const productFormId = bar.dataset.productFormId;
      const priceOutput = bar.querySelector('[data-sticky-atc-price]');
      const variantOutput = bar.querySelector('[data-sticky-atc-variant]');
      const stickyButton = bar.querySelector('[data-sticky-atc-button]');
      const stickyButtonText = bar.querySelector('[data-sticky-atc-button-text]');
      const mobileQuery = window.matchMedia('(max-width: 749px)');

      let sourceButton = null;
      let sourceForm = null;
      let scrollFrame = null;
      let contentFrame = null;

      const getSection = () =>
        document.getElementById(`shopify-section-${sectionId}`) || document;

      const getSourceElements = () => {
        const section = getSection();
        sourceForm = section.querySelector(`#${CSS.escape(productFormId)}`);
        sourceButton = sourceForm?.querySelector('button[name="add"]') || null;
      };

      const getPriceText = () => {
        const section = getSection();
        const priceRoot = section.querySelector(`#price-${CSS.escape(sectionId)}`);
        if (!priceRoot) return '';

        const salePrice = priceRoot.querySelector('.price-on-sale .price-item-sale');
        const regularPrice = priceRoot.querySelector('.price-regular .price-item-regular');
        const priceNode = salePrice || regularPrice;

        return priceNode?.textContent?.replace(/\s+/g, ' ').trim() || '';
      };

      const getVariantText = () => {
        const section = getSection();
        const radios = section.querySelector('variant-radios');
        if (radios) {
          return Array.from(radios.querySelectorAll('input[type="radio"]:checked'))
            .map((input) => input.value)
            .filter(Boolean)
            .join(' / ');
        }

        const selects = section.querySelector('variant-selects');
        if (selects) {
          return Array.from(selects.querySelectorAll('select'))
            .map((select) => select.selectedOptions[0]?.textContent?.trim())
            .filter(Boolean)
            .join(' / ');
        }

        return variantOutput?.textContent?.trim() || '';
      };

      const hideBar = () => {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('pr-mobile-sticky-atc-visible');
      };

      const showBar = () => {
        bar.classList.add('is-visible');
        bar.setAttribute('aria-hidden', 'false');
        document.body.classList.add('pr-mobile-sticky-atc-visible');
      };

      const footerIsVisible = () => {
        const footer = document.querySelector('footer.footer');
        if (!footer) return false;
        const rect = footer.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
      };

      const updateVisibility = () => {
        if (!mobileQuery.matches || !sourceButton || sourceButton.disabled || footerIsVisible()) {
          hideBar();
          return;
        }

        const rect = sourceButton.getBoundingClientRect();
        if (rect.bottom < 0) showBar();
        else hideBar();
      };

      const syncContent = () => {
        getSourceElements();

        if (!sourceButton || !sourceForm || sourceForm.closest('product-form')?.classList.contains('visually-hidden')) {
          hideBar();
          return;
        }

        const priceText = getPriceText();
        if (priceText && priceOutput) priceOutput.textContent = priceText;

        if (variantOutput) {
          const variantText = getVariantText();
          variantOutput.textContent = variantText;
          variantOutput.hidden = !variantText || variantText === 'Default Title';
        }

        const sourceLabel = sourceButton.querySelector('span')?.textContent?.replace(/\s+/g, ' ').trim();
        if (sourceLabel && stickyButtonText) stickyButtonText.textContent = sourceLabel;

        const isBusy =
          sourceButton.classList.contains('loading') ||
          sourceButton.getAttribute('aria-disabled') === 'true';

        stickyButton.disabled = sourceButton.disabled || isBusy;
        stickyButton.setAttribute('aria-busy', isBusy ? 'true' : 'false');
        updateVisibility();
      };

      const scheduleVisibilityUpdate = () => {
        if (scrollFrame) return;
        scrollFrame = window.requestAnimationFrame(() => {
          updateVisibility();
          scrollFrame = null;
        });
      };

      const scheduleContentSync = () => {
        if (contentFrame) return;
        contentFrame = window.requestAnimationFrame(() => {
          contentFrame = null;
          syncContent();
        });
      };

      stickyButton.addEventListener('click', () => {
        getSourceElements();
        if (!sourceButton || sourceButton.disabled) return;
        sourceButton.click();
        window.requestAnimationFrame(syncContent);
      });

      const section = getSection();
      const observer = new MutationObserver(scheduleContentSync);
      const productInfo = section.querySelector('.product-info');

      if (productInfo) {
        observer.observe(productInfo, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class', 'value'],
        });
      }

      section.addEventListener('change', scheduleContentSync);

      window.addEventListener('scroll', scheduleVisibilityUpdate, { passive: true });
      window.addEventListener('resize', scheduleVisibilityUpdate, { passive: true });
      mobileQuery.addEventListener?.('change', syncContent);

      syncContent();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["my-toyota-garage"] && !Shopify.designMode) return;
  try {
    (() => {
  const storageKey = 'preserve_rad_my_toyota_v1';
  const filterKey = 'preserve_rad_my_toyota_filter_v1';
  const yearMin = 1979;
  const yearMax = 1995;
  const modelRanges = [
    { value: '4Runner', label: '4Runner', start: 1984, end: 1995 },
    { value: 'Pickup', label: 'Pickup', start: 1979, end: 1995 },
    { value: 'Corolla AE86', label: 'Corolla AE86', start: 1983, end: 1987 },
    { value: 'MR2 AW11', label: 'MR2 AW11', start: 1984, end: 1989 }
  ];

  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const normalize = value => String(value || '').toLowerCase().replace(/[–—]/g, '-').replace(/\s+/g, ' ').trim();

  const engineOptions = (model, year) => {
    if (model === '4Runner') {
      if (year === 1984) return ['22R'];
      if (year === 1985) return ['22R', '22RE'];
      if (year >= 1986 && year <= 1987) return ['22RE', '22R-TE'];
      return ['22RE', '3VZ-E'];
    }
    if (model === 'Pickup') {
      if (year <= 1980) return ['20R'];
      if (year >= 1981 && year <= 1983) return ['22R'];
      if (year === 1984 || year === 1985) return ['22R', '22RE'];
      if (year >= 1986 && year <= 1987) return ['22R', '22RE', '22R-TE'];
      if (year === 1988) return ['22R', '22RE', '22R-TE', '3VZ-E'];
      if (year === 1989 || year === 1990) return ['22R', '22RE', '3VZ-E'];
      return ['22RE', '3VZ-E'];
    }
    if (model === 'Corolla AE86') {
      if (year === 1983) return ['4A-GE', '3S-GE'];
      return ['4A-C', '4A-GE', '3S-GE'];
    }
    if (model === 'MR2 AW11') return year >= 1986 ? ['4A-GE', '4A-GZE'] : ['4A-GE'];
    return [];
  };

  const drivetrainOptions = (model, year) => {
    if (model === '4Runner') return year <= 1989 ? ['4WD'] : ['2WD', '4WD'];
    if (model === 'Pickup') return ['2WD', '4WD'];
    return ['RWD'];
  };

  const transmissionOptions = (model, engine) => {
    if (model === 'Corolla AE86' && (engine === '4A-GE' || engine === '3S-GE')) return ['Manual'];
    return ['Manual', 'Automatic'];
  };

  const truckClassOptions = (model, drivetrain) =>
    model === 'Pickup' && drivetrain !== '4WD' ? ['1/2-Ton', '3/4-Ton', '1-Ton'] : [];

  const isSupportedVehicle = vehicle => {
    if (!vehicle) return false;

    const year = Number(vehicle.year);
    const range = modelRanges.find(item => item.value === vehicle.model);
    if (!range || year < range.start || year > range.end) return false;
    if (vehicle.engine && !engineOptions(vehicle.model, year).includes(vehicle.engine)) return false;
    if (vehicle.drivetrain && !drivetrainOptions(vehicle.model, year).includes(vehicle.drivetrain)) return false;
    if (vehicle.transmission && !transmissionOptions(vehicle.model, vehicle.engine).includes(vehicle.transmission)) return false;
    if (
      vehicle.truckClass &&
      (
        vehicle.model !== 'Pickup' ||
        vehicle.drivetrain === '4WD' ||
        !truckClassOptions(vehicle.model, vehicle.drivetrain).includes(vehicle.truckClass)
      )
    ) return false;

    return true;
  };

  const setOptions = (select, values, placeholder) => {
    const previousValue = select.value;
    const optionValues = [];

    select.innerHTML = '';
    const first = document.createElement('option');
    first.value = '';
    first.textContent = placeholder;
    select.append(first);

    values.forEach(item => {
      const option = document.createElement('option');

      if (typeof item === 'string') {
        option.value = item;
        option.textContent = item;
      } else {
        option.value = item.value;
        option.textContent = item.label;
      }

      optionValues.push(option.value);
      select.append(option);
    });

    if (values.length === 1) {
      select.value = optionValues[0];
    } else if (previousValue && optionValues.includes(previousValue)) {
      select.value = previousValue;
    }

    select.disabled = values.length === 0;
  };

  const memoryStorage = {};

  const readCookie = key => {
    try {
      const match = document.cookie
        .split('; ')
        .find(row => row.startsWith(encodeURIComponent(key) + '='));
      return match ? decodeURIComponent(match.split('=').slice(1).join('=')) : null;
    } catch (_) {
      return null;
    }
  };

  const writeCookie = (key, value) => {
    try {
      document.cookie = encodeURIComponent(key) + '=' + encodeURIComponent(value) + '; path=/; max-age=31536000; SameSite=Lax';
      return true;
    } catch (_) {
      return false;
    }
  };

  const removeCookie = key => {
    try {
      document.cookie = encodeURIComponent(key) + '=; path=/; max-age=0; SameSite=Lax';
    } catch (_) {}
  };

  const storageGet = key => {
    try {
      const value = window.localStorage.getItem(key);
      if (value !== null) return value;
    } catch (_) {}
    const cookieValue = readCookie(key);
    if (cookieValue !== null) return cookieValue;
    return Object.prototype.hasOwnProperty.call(memoryStorage, key) ? memoryStorage[key] : null;
  };

  const storageSet = (key, value) => {
    let saved = false;
    try {
      window.localStorage.setItem(key, value);
      saved = window.localStorage.getItem(key) === value;
    } catch (_) {}
    if (!saved) saved = writeCookie(key, value);
    memoryStorage[key] = value;
    return saved;
  };

  const storageRemove = key => {
    try { window.localStorage.removeItem(key); } catch (_) {}
    removeCookie(key);
    delete memoryStorage[key];
  };

  const readGarage = () => {
    try { return JSON.parse(storageGet(storageKey) || 'null'); }
    catch (_) { return null; }
  };

  const saveGarage = vehicle => storageSet(storageKey, JSON.stringify(vehicle));
  const clearGarage = () => storageRemove(storageKey);

  const modelTokens = model => {
    if (model === '4Runner') return ['4runner'];
    if (model === 'Pickup') return ['pickup'];
    if (model === 'Corolla AE86') return ['ae86', 'corolla'];
    if (model === 'MR2 AW11') return ['mr2', 'aw11'];
    return [normalize(model)];
  };

  const yearMatchesLine = (line, year) => {
    const productionRanges = Array.from(
      line.matchAll(/(?:0?[1-9]|1[0-2])\/(19\d{2}|20\d{2})\s*-\s*(?:0?[1-9]|1[0-2])\/(19\d{2}|20\d{2})/g)
    );
    if (productionRanges.some(match => year >= Number(match[1]) && year <= Number(match[2]))) return true;

    const ranges = Array.from(line.matchAll(/(19\d{2}|20\d{2})\s*-\s*(?:(19|20)?(\d{2,4}))/g));
    if (ranges.some(match => {
      const start = Number(match[1]);
      const rawEnd = match[3];
      const end = rawEnd.length === 2 ? Math.floor(start / 100) * 100 + Number(rawEnd) : Number(rawEnd);
      return year >= start && year <= end;
    })) return true;

    const years = Array.from(line.matchAll(/\b(19\d{2}|20\d{2})\b/g)).map(match => Number(match[1]));
    return years.includes(year);
  };

  const listContains = (list, selected) => {
    if (!Array.isArray(list) || list.length === 0 || !selected) return true;
    const target = normalize(selected);
    return list.some(value => normalize(value) === target);
  };

  const explicitTokens = (text, values) => {
    const normalizedText = normalize(text);
    return values.filter(value => {
      const token = normalize(value);
      const escaped = token.replace(/[.*+?^$()|[\\]\\\\]/g, '\\$&');
      return new RegExp('(^|[^a-z0-9])' + escaped + '([^a-z0-9]|$)').test(normalizedText);
    });
  };

  const vehicleKeyFor = vehicle => {
    if (!vehicle) return '';
    const year = Number(vehicle.year);

    if (vehicle.model === '4Runner') {
      if (year >= 1984 && year <= 1989) return '1st-gen-4runner';
      if (year >= 1990 && year <= 1995) return '2nd-gen-4runner';
    }

    if (vehicle.model === 'Pickup') {
      if (year >= 1979 && year <= 1983) return '1st-gen-pickup';
      if (year >= 1984 && year <= 1988) return '2nd-gen-pickup';
      if (year >= 1989 && year <= 1995) return '3rd-gen-pickup';
    }

    if (vehicle.model === 'Corolla AE86') return 'ae86';
    if (vehicle.model === 'MR2 AW11') return 'aw11-mr2';
    return '';
  };

  const statusFor = (data, vehicle) => {
    if (!vehicle || !data) return { status: 'unknown', reason: '' };

    if (Array.isArray(data.applications) && data.applications.length > 0) {
      const vehicleKey = vehicleKeyFor(vehicle);
      const year = Number(vehicle.year);
      const vehicleApps = data.applications.filter(app => normalize(app.vehicle_key) === normalize(vehicleKey));

      if (!vehicleApps.length) return { status: 'mismatch', reason: 'This product is not listed for the saved model.' };

      const yearApps = vehicleApps.filter(app => {
        const startYear = Number(app.year_start);
        const endYear = Number(app.year_end);
        return year >= startYear && year <= endYear;
      });

      if (!yearApps.length) return { status: 'mismatch', reason: 'This product is not listed for the saved model year.' };

      const matchingApp = yearApps.find(app =>
        listContains(app.engines, vehicle.engine) &&
        listContains(app.drivetrains, vehicle.drivetrain) &&
        listContains(app.transmissions, vehicle.transmission) &&
        listContains(app.truck_classes, vehicle.truckClass)
      );

      if (!matchingApp) {
        const engineMatch = yearApps.some(app => listContains(app.engines, vehicle.engine));
        if (!engineMatch) return { status: 'mismatch', reason: 'The saved engine is not listed for this application.' };

        const drivetrainMatch = yearApps.some(app =>
          listContains(app.engines, vehicle.engine) &&
          listContains(app.drivetrains, vehicle.drivetrain)
        );
        if (!drivetrainMatch) return { status: 'mismatch', reason: 'The saved drivetrain is not listed for this application.' };

        const transmissionMatch = yearApps.some(app =>
          listContains(app.engines, vehicle.engine) &&
          listContains(app.drivetrains, vehicle.drivetrain) &&
          listContains(app.transmissions, vehicle.transmission)
        );
        if (!transmissionMatch) return { status: 'mismatch', reason: 'The saved transmission is not listed for this application.' };

        return { status: 'mismatch', reason: 'The saved truck class is not listed for this application.' };
      }

      const notes = normalize(matchingApp.notes);
      const conditionalWords = ['solid axle conversion', 'requires modification', 'modified vehicle', 'swap required'];
      if (conditionalWords.some(word => notes.includes(word))) {
        return { status: 'conditional', reason: 'Your vehicle is listed, but this specific application requires an additional conversion or modification.' };
      }

      return { status: 'match', reason: 'This product is listed as a direct fit for your saved vehicle configuration.' };
    }

    const compat = normalize(data.compatibility);
    if (!compat) return { status: 'unknown', reason: 'Fitment data is not structured enough to compare automatically.' };

    const segmentedCompat = compat
      .replace(/\s+(?=(?:19\d{2}|20\d{2})\s*-\s*(?:(?:19|20)?\d{2,4})\s+toyota\b)/g, '\n')
      .replace(/\s+(?=(?:position|fitment notes|fitment requirements|requirements|exclusions|installation|brake system|brake configuration|drivetrain|engine|transmission|available configurations):)/g, '\n');

    const tokens = modelTokens(vehicle.model);
    const lines = segmentedCompat.split(/\n+/).map(line => line.trim()).filter(Boolean);
    const modelLines = lines.filter(line => tokens.some(token => line.includes(token)));
    if (!modelLines.length) return { status: 'mismatch', reason: 'This product is not listed for the saved model.' };

    const matchedYearLines = modelLines.filter(line => yearMatchesLine(line, Number(vehicle.year)));
    if (!matchedYearLines.length) return { status: 'mismatch', reason: 'This product is not listed for the saved model year.' };

    const knownEngines = ['20R','22R','22RE','22R-TE','3VZ-E','3S-GE','4A-C','4A-GE','4A-GZE'];
    const knownDrivetrains = ['2WD','4WD','RWD','FWD','AWD'];
    const knownTransmissions = ['Manual','Automatic'];

    if (vehicle.model === 'Pickup' && vehicle.truckClass) {
      if (Array.isArray(data.truckClass) && data.truckClass.length > 0) {
        if (!listContains(data.truckClass, vehicle.truckClass)) {
          return { status: 'mismatch', reason: 'This product is not listed for the saved truck class.' };
        }
      }
    }

    let foundCompatibleApplication = false;
    let onlyConditional = false;

    for (const line of matchedYearLines) {
      const lineEngines = explicitTokens(line, knownEngines);
      const lineDrivetrains = explicitTokens(line, knownDrivetrains);
      const lineTransmissions = explicitTokens(line, knownTransmissions);

      const engineOk = !vehicle.engine || lineEngines.length === 0 || lineEngines.some(value => normalize(value) === normalize(vehicle.engine));
      const drivetrainOk = !vehicle.drivetrain || lineDrivetrains.length === 0 || lineDrivetrains.some(value => {
        const candidate = normalize(value);
        const selected = normalize(vehicle.drivetrain);
        if ((candidate === 'rwd' && selected === '2wd') || (candidate === '2wd' && selected === 'rwd')) return true;
        return candidate === selected;
      });
      const transmissionOk = !vehicle.transmission || lineTransmissions.length === 0 || lineTransmissions.some(value => normalize(value) === normalize(vehicle.transmission));

      if (!engineOk || !drivetrainOk || !transmissionOk) continue;
      const ae86ThreeSgeSwap = vehicle.model === 'Corolla AE86' && vehicle.engine === '3S-GE';
      if (lineEngines.length === 0 && !ae86ThreeSgeSwap && !listContains(data.engine, vehicle.engine)) continue;
      if (lineDrivetrains.length === 0 && !listContains(data.drivetrain, vehicle.drivetrain)) continue;
      if (lineTransmissions.length === 0 && !listContains(data.transmission, vehicle.transmission)) continue;

      foundCompatibleApplication = true;
      const conditionalWords = ['solid axle conversion', 'requires modification', 'modified vehicle', 'swap required'];
      const conditional = conditionalWords.some(word => line.includes(word));
      if (!conditional) {
        if (vehicle.model === 'Pickup' && vehicle.truckClass && (!Array.isArray(data.truckClass) || data.truckClass.length === 0)) {
          return { status: 'unknown', reason: 'This product matches the saved vehicle details, but its Truck Class metafield has not been specified yet.' };
        }
        return { status: 'match', reason: 'This product is listed as a direct fit for your saved vehicle configuration.' };
      }
      onlyConditional = true;
    }

    if (foundCompatibleApplication && onlyConditional) return { status: 'conditional', reason: 'Your vehicle is listed, but this specific application requires an additional conversion or modification.' };
    return { status: 'mismatch', reason: 'This product is not listed for the saved vehicle details.' };
  };

  const shortVehicle = vehicle => vehicle ? `${vehicle.year} ${vehicle.model}` : '';
  const fullVehicle = vehicle => vehicle
    ? [`${vehicle.year} ${vehicle.model}`, vehicle.truckClass, vehicle.engine, vehicle.drivetrain, vehicle.transmission].filter(Boolean).join(' · ')
    : '';

  const parseSource = source => {
    try { return JSON.parse(source.textContent); }
    catch (_) { return null; }
  };

  const updateSummary = vehicle => {
    $$('[data-pr-garage-summary]').forEach(el => {
      el.textContent = vehicle ? fullVehicle(vehicle) : 'Select your Toyota';
    });
  };

  const applyCards = vehicle => {
    $$('product-card').forEach(card => {
      const source = $('.pr-fitment-source[data-pr-fitment-context="card"]', card);
      const info = $('.card-info', card);
      if (!source || !info) return;
      const old = $('.pr-fitment-card-status', info);
      const gridItem = card.closest('.grid-item');

      if (!vehicle) {
        if (old) old.remove();
        card.classList.remove('pr-garage-hidden');
        if (gridItem) gridItem.classList.remove('pr-garage-hidden');
        return;
      }

      const result = statusFor(parseSource(source), vehicle);
      const badge = old || document.createElement('div');
      badge.className = 'pr-fitment-card-status';
      badge.dataset.status = result.status;
      const nextText =
        result.status === 'match' ? `✓ Fits your ${shortVehicle(vehicle)}` :
        result.status === 'conditional' ? `△ Check fitment for your ${shortVehicle(vehicle)}` :
        result.status === 'mismatch' ? `Not listed for your ${shortVehicle(vehicle)}` :
        'Check fitment details';
      if (badge.textContent !== nextText) badge.textContent = nextText;
      if (badge.title !== result.reason) badge.title = result.reason;
      if (!old) info.prepend(badge);

      const filterOn =
        window.location.pathname.includes('/collections/') &&
        storageGet(filterKey) === 'true';
      const shouldHide = filterOn && result.status === 'mismatch';

      card.classList.remove('pr-garage-hidden');
      if (gridItem) {
        gridItem.classList.toggle('pr-garage-hidden', shouldHide);
      } else {
        card.classList.toggle('pr-garage-hidden', shouldHide);
      }
    });
  };

  const applyProductPage = vehicle => {
    const wrap = $('[data-pr-product-fitment-wrap]');
    const banner = $('[data-pr-product-fitment]');
    const source = $('.pr-fitment-source[data-pr-fitment-context="product"]');
    if (!wrap || !banner || !source) return;
    if (!vehicle) {
      wrap.hidden = true;
      return;
    }
    const result = statusFor(parseSource(source), vehicle);
    banner.dataset.status = result.status;
    banner.innerHTML =
      result.status === 'match' ? `✓ <strong>Fits your Toyota:</strong> ${fullVehicle(vehicle)}<br><span>${result.reason}</span>` :
      result.status === 'conditional' ? `△ <strong>Fitment check required:</strong> ${fullVehicle(vehicle)}<br><span>${result.reason}</span>` :
      result.status === 'mismatch' ? `<strong>Not listed for your saved Toyota:</strong> ${fullVehicle(vehicle)}<br><span>${result.reason}</span>` :
      `<strong>Check fitment details:</strong> ${fullVehicle(vehicle)}<br><span>${result.reason}</span>`;
    wrap.hidden = false;
  };

  const garageVehicleTags = [
    'pr-vehicle-1st-gen-pickup',
    'pr-vehicle-2nd-gen-pickup',
    'pr-vehicle-3rd-gen-pickup',
    'pr-vehicle-1st-gen-4runner',
    'pr-vehicle-2nd-gen-4runner',
    'pr-vehicle-ae86',
    'pr-vehicle-aw11-mr2'
  ];

  const garageTagFor = vehicle => {
    if (!vehicle) return '';
    const year = Number(vehicle.year);

    if (vehicle.model === 'Pickup') {
      if (year >= 1979 && year <= 1983) return 'pr-vehicle-1st-gen-pickup';
      if (year >= 1984 && year <= 1988) return 'pr-vehicle-2nd-gen-pickup';
      if (year >= 1989 && year <= 1995) return 'pr-vehicle-3rd-gen-pickup';
    }

    if (vehicle.model === '4Runner') {
      if (year >= 1984 && year <= 1989) return 'pr-vehicle-1st-gen-4runner';
      if (year >= 1990 && year <= 1995) return 'pr-vehicle-2nd-gen-4runner';
    }

    if (vehicle.model === 'Corolla AE86') return 'pr-vehicle-ae86';
    if (vehicle.model === 'MR2 AW11') return 'pr-vehicle-aw11-mr2';

    return '';
  };

  const parseCollectionPath = pathname => {
    const match = pathname.match(/^(.*\/collections\/[^/]+)(?:\/([^/?#]+))?\/?$/);
    if (!match) return null;
    return {
      base: match[1],
      tags: match[2] ? match[2].split('+').filter(Boolean) : []
    };
  };

  const applyGarageMetafieldFilters = (url, vehicle) => {
    const engineKey = 'filter.p.m.custom.engine';
    const drivetrainKey = 'filter.p.m.custom.drivetrain';
    const transmissionKey = 'filter.p.m.custom.transmission';
    const truckClassKey = 'filter.p.m.custom.truck_class';

    if (vehicle.model === 'Corolla AE86' && vehicle.engine === '3S-GE') {
      url.searchParams.delete(engineKey);
    } else if (vehicle.engine) {
      url.searchParams.set(engineKey, vehicle.engine);
    } else {
      url.searchParams.delete(engineKey);
    }

    if (vehicle.drivetrain) {
      url.searchParams.set(drivetrainKey, vehicle.drivetrain);
    } else {
      url.searchParams.delete(drivetrainKey);
    }

    if (vehicle.transmission) {
      url.searchParams.set(transmissionKey, vehicle.transmission);
    } else {
      url.searchParams.delete(transmissionKey);
    }

    if (vehicle.model === 'Pickup' && vehicle.drivetrain !== '4WD' && vehicle.truckClass) {
      url.searchParams.set(truckClassKey, vehicle.truckClass);
    } else {
      url.searchParams.delete(truckClassKey);
    }
  };

  const buildGarageCollectionUrl = (vehicle, resetPage = false, preferBestSelling = false) => {
    const parsed = parseCollectionPath(window.location.pathname);
    const garageTag = garageTagFor(vehicle);
    if (!parsed || !garageTag) return null;

    const url = new URL(window.location.href);
    const preservedTags = parsed.tags.filter(tag => !garageVehicleTags.includes(tag));
    const tags = [...new Set([...preservedTags, garageTag])];

    url.pathname = `${parsed.base}/${tags.join('+')}`;
    applyGarageMetafieldFilters(url, vehicle);
    url.searchParams.set('pr_garage', '1');
    if (preferBestSelling) url.searchParams.set('sort_by', 'best-selling');
    if (resetPage) url.searchParams.delete('page');

    return url;
  };

  const buildGarageAllProductsUrl = vehicle => {
    const garageTag = garageTagFor(vehicle);
    if (!garageTag) return null;

    const url = new URL(window.location.href);
    const root = window.Shopify?.routes?.root || '/';
    const normalizedRoot = root.endsWith('/') ? root : `${root}/`;
    const previewParams = new URLSearchParams();

    ['preview_theme_id', 'pb', '_fd'].forEach(key => {
      const value = url.searchParams.get(key);
      if (value !== null) previewParams.set(key, value);
    });

    url.pathname = `${normalizedRoot}collections/all/${garageTag}`.replace(/\/+/g, '/');
    url.search = '';

    previewParams.forEach((value, key) => url.searchParams.set(key, value));
    applyGarageMetafieldFilters(url, vehicle);
    url.searchParams.set('pr_garage', '1');
    url.searchParams.set('sort_by', 'best-selling');

    return url;
  };

  const buildClearedGarageCollectionUrl = (resetPage = true) => {
    const url = new URL(window.location.href);
    if (url.searchParams.get('pr_garage') !== '1') return null;

    const parsed = parseCollectionPath(url.pathname);
    if (!parsed) return null;

    const remainingTags = parsed.tags.filter(tag => !garageVehicleTags.includes(tag));
    url.pathname = remainingTags.length ? `${parsed.base}/${remainingTags.join('+')}` : parsed.base;

    url.searchParams.delete('filter.p.m.custom.engine');
    url.searchParams.delete('filter.p.m.custom.drivetrain');
    url.searchParams.delete('filter.p.m.custom.transmission');
    url.searchParams.delete('filter.p.m.custom.truck_class');
    url.searchParams.delete('pr_garage');
    if (resetPage) url.searchParams.delete('page');

    return url;
  };

  const syncCollectionGarageFilter = (vehicle, enabled, resetPage = false, preferBestSelling = false) => {
    if (!window.location.pathname.includes('/collections/')) return false;

    const target = enabled
      ? buildGarageCollectionUrl(vehicle, resetPage, preferBestSelling)
      : buildClearedGarageCollectionUrl(resetPage);
    if (!target || target.href === window.location.href) return false;

    window.location.assign(target.href);
    return true;
  };

  const refresh = () => {
    const vehicle = readGarage();
    updateSummary(vehicle);
    applyCards(vehicle);
    applyProductPage(vehicle);
  };

  const init = () => {
    const dialog = $('[data-pr-garage-dialog]');
    const year = $('[data-pr-year]');
    const model = $('[data-pr-model]');
    const engine = $('[data-pr-engine]');
    const drive = $('[data-pr-drive]');
    const transmission = $('[data-pr-transmission]');
    const truckClass = $('[data-pr-truck-class]');
    const truckClassField = $('[data-pr-truck-class-field]');
    const filter = $('[data-pr-garage-filter]');
    const shopMatching = $('[data-pr-garage-shop]');
    if (!dialog || !year || !model || !engine || !drive || !transmission || !truckClass || !truckClassField) return;

    const years = [];
    for (let y = yearMax; y >= yearMin; y -= 1) years.push(String(y));
    setOptions(year, years, 'Select year');
    setOptions(model, [], 'Select model');
    setOptions(engine, [], 'Select engine');
    setOptions(drive, [], 'Select drivetrain');
    setOptions(transmission, [], 'Select transmission');
    setOptions(truckClass, [], 'Select truck class (optional)');

    const updateTransmissionOptions = () => {
      setOptions(transmission, transmissionOptions(model.value, engine.value), 'Select transmission (optional)');
    };

    const updateTruckClassOptions = () => {
      const hideTruckClass = model.value !== 'Pickup' || drive.value === '4WD';
      truckClassField.hidden = hideTruckClass;
      setOptions(
        truckClass,
        hideTruckClass ? [] : truckClassOptions(model.value, drive.value),
        'Select truck class (optional)'
      );
    };

    const updateVehicleOptions = () => {
      const y = Number(year.value);
      setOptions(engine, engineOptions(model.value, y), 'Select engine (optional)');
      setOptions(drive, drivetrainOptions(model.value, y), 'Select drivetrain (optional)');
      updateTransmissionOptions();
      updateTruckClassOptions();
    };

    const updateModels = () => {
      const y = Number(year.value);
      const options = modelRanges.filter(item => y >= item.start && y <= item.end);
      setOptions(model, options, 'Select model');

      if (model.value) {
        updateVehicleOptions();
      } else {
        setOptions(engine, [], 'Select engine (optional)');
        setOptions(drive, [], 'Select drivetrain (optional)');
        setOptions(transmission, [], 'Select transmission (optional)');
        setOptions(truckClass, [], 'Select truck class (optional)');
        truckClassField.hidden = true;
      }
    };

    year.addEventListener('change', updateModels);
    model.addEventListener('change', updateVehicleOptions);
    engine.addEventListener('change', updateTransmissionOptions);
    drive.addEventListener('change', updateTruckClassOptions);

    $$('[data-pr-garage-open]').forEach(button => button.addEventListener('click', () => {
      const saved = readGarage();
      if (saved) {
        year.value = String(saved.year);
        updateModels();
        model.value = saved.model;
        updateVehicleOptions();
        if (saved.engine) engine.value = saved.engine;
        updateTransmissionOptions();
        if (saved.drivetrain) drive.value = saved.drivetrain;
        updateTruckClassOptions();
        if (saved.transmission) transmission.value = saved.transmission;
        if (saved.truckClass && saved.model === 'Pickup' && saved.drivetrain !== '4WD') {
          truckClass.value = saved.truckClass;
        }
      }
      if (!dialog.open) {
        try {
          dialog.showModal();
        } catch (_) {
          dialog.setAttribute('open', '');
        }
      }
    }));

    $('[data-pr-garage-close]')?.addEventListener('click', () => dialog.close());

    $('[data-pr-garage-clear]')?.addEventListener('click', () => {
      clearGarage();
      storageSet(filterKey, 'false');
      if (filter) filter.checked = false;
      dialog.close();

      if (syncCollectionGarageFilter(null, false, true)) return;

      refresh();
    });

    const handleSave = () => {
      const vehicle = {
        year: Number(year.value),
        model: model.value,
        engine: engine.value,
        drivetrain: drive.value,
        transmission: transmission.value,
        truckClass: model.value === 'Pickup' && drive.value !== '4WD' ? truckClass.value : ''
      };

      if (!vehicle.year || !vehicle.model) {
        const firstMissing = [year, model].find(field => !field.value);
        if (firstMissing) firstMissing.focus();
        return;
      }

      saveGarage(vehicle);
      updateSummary(vehicle);
      dialog.close();

      if (filter && filter.checked && syncCollectionGarageFilter(vehicle, true, true, true)) return;

      applyCards(vehicle);
      applyProductPage(vehicle);
    };

    $('[data-pr-garage-save]')?.addEventListener('click', handleSave);

    $('[data-pr-garage-form]')?.addEventListener('submit', event => {
      event.preventDefault();
      handleSave();
    });

    if (filter) {
      filter.checked = storageGet(filterKey) === 'true';
      filter.addEventListener('change', () => {
        storageSet(filterKey, String(filter.checked));
        const vehicle = readGarage();

        if (filter.checked) {
          if (vehicle && syncCollectionGarageFilter(vehicle, true, true, true)) return;
        } else if (syncCollectionGarageFilter(vehicle, false, true)) {
          return;
        }

        refresh();
      });
    }

    shopMatching?.addEventListener('click', () => {
      const vehicle = readGarage();

      if (!vehicle) {
        if (!dialog.open) {
          try {
            dialog.showModal();
          } catch (_) {
            dialog.setAttribute('open', '');
          }
        }
        return;
      }

      storageSet(filterKey, 'true');
      const target = buildGarageAllProductsUrl(vehicle);
      if (target) window.location.assign(target.href);
    });

    let savedVehicle = readGarage();

    if (savedVehicle && !isSupportedVehicle(savedVehicle)) {
      clearGarage();
      storageSet(filterKey, 'false');
      if (filter) filter.checked = false;
      savedVehicle = null;

      if (syncCollectionGarageFilter(null, false, true)) return;
    }

    if (filter && filter.checked && savedVehicle && syncCollectionGarageFilter(savedVehicle, true, false)) return;

    document.addEventListener('shopify:section:load', () => {
      applyCards(readGarage());
      applyProductPage(readGarage());
    });
    refresh();
  };

  const scheduleInit = () => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(init, { timeout: 600 });
    } else {
      window.setTimeout(init, 1);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInit, { once: true });
  } else {
    scheduleInit();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    document.querySelectorAll('.product-media-gallery-wrap').forEach((galleryWrap) => {
      const counter = galleryWrap.querySelector('[data-pr-media-current]');
      const gallery = galleryWrap.querySelector('media-gallery');
      if (!counter || !gallery) return;

      const update = () => {
        const slides = Array.from(gallery.querySelectorAll('.product-media-main'));
        const active = gallery.querySelector('.product-media-main.is-active');
        const index = slides.indexOf(active);
        counter.textContent = index >= 0 ? String(index + 1) : '1';
      };

      const observer = new MutationObserver(update);
      gallery.querySelectorAll('.product-media-main').forEach((slide) => {
        observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
      });

      update();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
